<div
	class="slide slide--mentions-media"
	[style.--slide-accent-color]="titleColor"
>
	<div class="slide__header">
		<div class="slide__content-copy">
			<typography variant="h/2" class="slide__title">
				<app-report-inline-text
					[text]="title"
					[field]="textFields.title"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
			<div class="slide__date-row">
				<app-icon type="svg" [size]="14">calendar_today</app-icon>
				<typography variant="p/xs_regular" class="slide__date-text">
					{{ dateLabel }}
				</typography>
			</div>
			<typography variant="p/sm_regular" class="slide__summary">
				<app-report-inline-text
					[text]="summaryText"
					[field]="textFields.body"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
		</div>

		<div class="slide__kpi" *ngIf="!isEmpty && topSharePct">
			<typography variant="h/1" class="slide__kpi-value">
				{{ topSharePct }}
			</typography>
			<div class="slide__kpi-label-row">
				<span class="slide__kpi-dot"></span>
				<typography variant="p/sm_regular" class="slide__kpi-label">
					{{ topShareLabel }}
				</typography>
			</div>
		</div>
	</div>

	<div class="slide__body" *ngIf="!isEmpty">
		<div class="slide__chart-panel slide__chart-host">
			<div
				class="slide__donut-stage"
				*ngIf="chartData && !chartSwitch.block"
			>
				<div class="slide__chart-square">
					<canvas
						baseChart
						[data]="chartData"
						[options]="chartOptions"
						[type]="chartType"
					></canvas>
				</div>
			</div>
			<app-report-chart-switch
				[state]="chartSwitch"
				[themeColor]="themeColor"
				[editorMode]="editorMode"
				(chartTypeChange)="chartTypeChange.emit($event)"
			></app-report-chart-switch>
		</div>

		<div class="slide__table-panel">
			<typography variant="p/base_semibold" class="slide__table-title">
				Channel breakdown
			</typography>
			<div class="slide__table">
				<div class="slide__table-head">
					<typography
						variant="p/xs_medium"
						class="slide__table-head-cell"
					>
						Channel
					</typography>
					<typography
						variant="p/xs_medium"
						class="slide__table-head-cell slide__table-head-cell--right"
					>
						Mentions
					</typography>
					<typography
						variant="p/xs_medium"
						class="slide__table-head-cell slide__table-head-cell--right"
					>
						Share
					</typography>
				</div>
				<div class="slide__table-body">
					<div class="slide__table-row" *ngFor="let row of tableRows">
						<div
							class="slide__table-cell slide__table-cell--channel"
						>
							<span
								class="slide__channel-dot"
								[style.background]="row.color"
							></span>
							<typography
								variant="p/sm_regular"
								class="slide__channel-label"
							>
								{{ row.label }}
							</typography>
						</div>
						<typography
							variant="p/sm_semibold"
							class="slide__table-cell slide__table-cell--right"
						>
							{{ row.value | number }}
						</typography>
						<typography
							variant="p/sm_semibold"
							class="slide__table-cell slide__table-cell--right"
						>
							{{ row.percent }}
						</typography>
					</div>
				</div>
			</div>
		</div>
	</div>

	<app-slide-no-data *ngIf="isEmpty"></app-slide-no-data>

	<div class="slide__footer">
		<app-report-slide-brand class="slide__footer-left">
			<typography variant="p/xxs_regular" class="slide__footer-copy">
				Powered by
			</typography>
			<typography variant="p/xxs_semibold" class="slide__footer-brand">
				lolly
			</typography>
		</app-report-slide-brand>
		<div class="slide__footer-tag">mentions by media type</div>
	</div>
</div>
